import React from 'react';
import PropTypes from 'prop-types';
import './style';

const propTypes = {
  stats: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  label: PropTypes.string.isRequired,
  label2: PropTypes.string,
};
const defaultProps = {
  label2: null,
};

function StatsItem({ stats, label, label2 }) {
  return (
    <div className="bsa-stats-item">
      <h1>{stats}</h1>
      <div><strong>{label}</strong></div>
      <div className="subtitle-4 font--bold text--primary">{label2}</div>
    </div>
  );
}

StatsItem.propTypes = propTypes;
StatsItem.defaultProps = defaultProps;
export default StatsItem;
